import { reatomAsync } from "@reatom/async";
import { ExportTaskIdDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { toastHandler, truncateStart } from "src/util";

export const retryExportJobRequest = reatomAsync(
  async (_, data: ExportTaskIdDto) => {
    API.exporterQueueApi
      .exportControllerRetryExportJob(data)
      .then((response) => {
        if (response.data)
          toastHandler.success({
            name: "retryExportJob",
            title: "Перезапуск задачи",
            content: `Задача ${truncateStart(data.id)} перезапущенна`,
          });
      });
  },
  "retryExportJobRequest",
);
